import React from "react";
import Layout from "../components/layout/Layout";
import BannerCTA from "../components/shared/BannerCTA";

const PrivacyPolicy: React.FC = () => {
    return (
        <Layout>
            <div className="policy-header">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last Updated: January 2026</p>
            </div>
            
            <div className="policy-content-wrapper">
                <div className="policy-content">
                    <div className="policy-section">
                        <p>Your privacy is important to us at Ventus Travel. We respect your privacy regarding any information we may collect from you across our website.</p>
                        <h3>1. DATA PROTECTION</h3>
                                <p>
                                    Ventus Travel respects your privacy and is committed to protecting your personal data. We are committed to keeping your data safe and secure and handling it appropriately within the guidelines of the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.
                                </p>
                                <p>
                                    This policy explains how we may collect information about you and then use it in order to satisfy your travel booking requirements. It also outlines the security measures we take in order to protect your privacy and gives assurances on things that we will not do.
                                </p>
                                <p>
                                    When you register with us or make a booking, we collect some of your personal information including your name, email address, date of birth, city of residence, phone number and payment card information. We also may monitor customer search and booking patterns and site use which enables us to improve our service. Our site records your IP address at the time of booking, and we collect data for fraud prevention.
                                </p>
                                <p>
                                    If you would like any more information, or if you would like to contact us about our privacy policy, please email us at the address provided on our contact page.
                                </p>
                                <p>
                                    We may amend this policy from time to time, in which case the amended version will be published on our website. This policy applies to personal information held about individuals. It does not apply to information we hold about companies and other organisations.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>2. USE OF INFORMATION</h3>
                                <p>
                                    We will only use your personal data when the law allows us to. We will use personal information about you for a number of purposes, including:
                                </p>
                                <ul>
                                    <li>Servicing your account and managing our relationship with you</li>
                                    <li>To deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you</li>
                                    <li>To enable you to take part in our competitions and promotions</li>
                                    <li>For the purpose of completing travel bookings (this includes sharing your booking information with other parties to fulfil your booking only)</li>
                                    <li>To advise you of any changes to or problems with a hotel booking</li>
                                    <li>To help us administer accounts, services and products which we offer</li>
                                    <li>Sending newsletters and marketing communications (where you have opted in)</li>
                                    <li>To proactively make individualised suggestions and recommendations</li>
                                </ul>
                    </div>

                    <div className="policy-section">
                        <h3>3. LEGAL BASIS FOR PROCESSING</h3>
                                <p>
                                    We will only process your personal data where we have a legal basis to do so. The legal bases we rely on include:
                                </p>
                                <p>
                                    <strong>Contract:</strong> Processing is necessary for the performance of a contract with you (e.g., to complete your travel booking).
                                </p>
                                <p>
                                    <strong>Legitimate Interests:</strong> Processing is necessary for our legitimate interests or those of a third party, provided your interests and fundamental rights do not override those interests.
                                </p>
                                <p>
                                    <strong>Consent:</strong> You have given clear consent for us to process your personal data for a specific purpose (e.g., marketing communications).
                                </p>
                                <p>
                                    <strong>Legal Obligation:</strong> Processing is necessary for compliance with a legal obligation.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>4. YOUR RIGHTS AND AMENDMENTS</h3>
                                <p>
                                    You can contact us about updating or accessing your information at any time. Under data protection law, you have the following rights:
                                </p>
                                <ul>
                                    <li>The right to access your personal data</li>
                                    <li>The right to rectification of inaccurate personal data</li>
                                    <li>The right to erasure (the "right to be forgotten")</li>
                                    <li>The right to restrict processing</li>
                                    <li>The right to data portability</li>
                                    <li>The right to object to processing</li>
                                    <li>Rights related to automated decision-making and profiling</li>
                                </ul>
                                <p>
                                    To update or delete any of your personal information we hold, you can contact us at any time and we will address your request in a timely manner. If you do not wish to receive marketing communications, you can unsubscribe at any time by contacting us or by clicking the "unsubscribe" button in any email.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>5. DISCLOSURE OF INFORMATION</h3>
                                <p>
                                    We do not sell or disclose information personally identifying you to other companies without your prior consent. We do not directly sell mailing lists to third parties.
                                </p>
                                <p>
                                    We may share your personal data with:
                                </p>
                                <ul>
                                    <li>Hotels and accommodation providers to fulfil your booking</li>
                                    <li>Payment processors to process your transactions securely</li>
                                    <li>Service providers who assist us in operating our website and services</li>
                                    <li>Law enforcement or regulatory bodies where required by law</li>
                                </ul>
                    </div>

                    <div className="policy-section">
                        <h3>6. PROTECTION OF INFORMATION</h3>
                                <p>
                                    We have put in place appropriate security measures to prevent your personal data from being lost, used, accessed, altered or disclosed in an unauthorised way.
                                </p>
                                <p>
                                    In addition, we limit access to your personal data to our employees who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.
                                </p>
                                <p>
                                    We maintain strict security measures in order to protect personal information. We follow procedures to ensure compliance with the UK GDPR and Data Protection Act 2018. Our security policy covers encryption, password compliance, firewall and penetration testing, breach handling, employee training and security, and more.
                                </p>
                                <p>
                                    We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>7. DATA RETENTION</h3>
                                <p>
                                    We will only retain your personal data for as long as reasonably necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting or reporting requirements.
                                </p>
                                <p>
                                    To determine the appropriate retention period for personal data, we consider the amount, nature and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting or other requirements.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>8. INTERNATIONAL TRANSFERS</h3>
                                <p>
                                    Some of our external third parties are based outside the United Kingdom, so their processing of your personal data will involve a transfer of data outside the UK.
                                </p>
                                <p>
                                    Whenever we transfer your personal data out of the UK, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented: transfers to countries deemed to provide adequate protection, use of specific contracts approved for use in the UK, or appropriate safeguards such as binding corporate rules.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>9. COOKIES</h3>
                                <p>
                                    Our website uses cookies (small data files saved to your computer) to distinguish you from other users of our website and improve how we understand you. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site.
                                </p>
                                <p>
                                    For detailed information about the cookies we use and the purposes for which we use them, please see our separate Cookie Policy.
                                </p>
                    </div>

                    <div className="policy-section">
                        <h3>10. CONTACT US</h3>
                                <p>
                                    If you have any questions about this Privacy Policy or our privacy practices, please contact us via our website at{" "}
                                    <a href="https://www.ventustravel.co.uk">www.ventustravel.co.uk</a> or through our contact page.
                                </p>
                                <p>
                                    You have the right to make a complaint at any time to the Information Commissioner's Office (ICO), the UK regulator for data protection issues (<a href="https://www.ico.org.uk" target="_blank" rel="noopener noreferrer">www.ico.org.uk</a>). We would, however, appreciate the chance to deal with your concerns before you approach the ICO, so please contact us in the first instance.
                                </p>
                    </div>
                </div>
            </div>
            <BannerCTA />
        </Layout>
    );
};

export default PrivacyPolicy;
